import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Gallery.css"; // You can create this file for modal styling

const getDirectImageUrl = (url) => {
  if (!url) return "";
  const match = url.match(/\/d\/([a-zA-Z0-9_-]+)/);
  if (!match) {
    console.warn("Failed to match Google Drive URL:", url);
  }
  return match ? `https://drive.google.com/uc?export=view&id=${match[1]}` : url;
};

const Gallery = () => {
  const [images, setImages] = useState([]);
  const [modalImage, setModalImage] = useState(null);
  const [displayedCount, setDisplayedCount] = useState(10);
  const GOOGLE_SHEET_ID = "11N3jvgXALNcJc_EZWE7ZgYLFJXB8aPp0wIxrE_gSjVs";
  const SHEET_NAME = "Sheet 1";

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const response = await axios.get(
          `https://opensheet.vercel.app/${GOOGLE_SHEET_ID}/${SHEET_NAME}`
        );
        setImages(response.data);
      } catch (error) {
        console.error("Error fetching gallery data:", error);
      }
    };

    fetchImages();
  }, []);

  const openModal = (img) => setModalImage(img);
  const closeModal = () => setModalImage(null);

  return (
    <section id="gallery" className="gallery-section uk-section">
      <div className="container--min uk-container">
        <h2 className="uk-h2 uk-margin-bottom">Gallery</h2>
        <div className="gallery-grid">
          {images.length === 0 ? (
            <p>Loading images...</p>
          ) : (
            images.slice(0, displayedCount).map((img, index) => (
              <div
                key={index}
                className="gallery-item"
                onClick={() => openModal(img)}
              >
                <img
                  src={getDirectImageUrl(img.imageUrl)}
                  alt={`Gallery ${index + 1}`}
                />
                {img.subtitle && (
                  <div className="gallery-subtitle">{img.subtitle}</div>
                )}
              </div>
            ))
          )}
        </div>
        {images.length > displayedCount && (
          <button
            className="load-more-btn"
            onClick={() => setDisplayedCount(displayedCount + 10)}
          >
            Load More
          </button>
        )}
      </div>

      {/* Modal */}
      {modalImage && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <img
              src={getDirectImageUrl(modalImage.imageUrl)}
              alt="Expanded"
              className="modal-image"
            />
            <p className="modal-subtitle">{modalImage.subtitle}</p>
            <button className="modal-close" onClick={closeModal}>
              &times;
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default Gallery;
